// you can import modules from the theme lib or even from
// NPM packages if they support it…
import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

import AOS from "aos/dist/aos";
import "owl.carousel/dist/owl.carousel";


// Initialise our components on jQuery.ready…
jQuery(function ($) {
	// ExampleComponent1.init();
	// ExampleModule2.init();
	// ReplaceObfuscatedEmailAddresses.init();
	// AnimateOnPageLinks.init();

	AOS.init();
	$(window).resize( function() {
		AOS.refresh();
	});
	$(window).scroll( function() {
		AOS.refresh();
	});

	function only_unique_values(value, index, self) { 
		return self.indexOf(value) === index;
	}

	function get_url_parameter(name) {
		return decodeURI(
			(RegExp(name + '=' + '(.+?)(&|$)').exec(location.search) || [, null])[1]);
	}

	var owlAdv = $('#advisory-links');
	owlAdv.owlCarousel({
		// nav: true,
		items: 1,
		loop: false,
		dots: false,
		// autoWidth: false,
	});

	$('.advPrev').click(function() {
		owlAdv.trigger('prev.owl.carousel');
	});

	$('.advNext').click(function() {
		owlAdv.trigger('next.owl.carousel');
	});

	var owlFoc = $('#focus-links');
	owlFoc.owlCarousel({
		// nav: true,
		items: 1,
		loop: false,
		dots: false,
		// autoWidth: false,
	});

	$('.focPrev').click(function() {
		owlFoc.trigger('prev.owl.carousel');
	});

	$('.focNext').click(function() {
		owlFoc.trigger('next.owl.carousel');
	});

	$("[data-toggle='sidebar-toggle']").click(function(event){
		event.preventDefault;
		$(".sidebar").toggleClass('active');
		$(".sidebar-overlay").toggleClass('active');
		$(".sidebar-screen").toggleClass('active');
		$("body").toggleClass('overflow-hidden');
	});

	var owlRec = $('#recent-links');
	owlRec.owlCarousel({
		// nav: true,
		items: 1,
		loop: false // autoWidth: false,
	});
	$('.recPrev').click(function () {
		owlRec.trigger('prev.owl.carousel');
	});
	$('.recNext').click(function () {
		owlRec.trigger('next.owl.carousel');
	});

	// $("document").on("click",function(event){
	// 	event.preventDefault;
	// 	console.log('asds');
	// });

	$(".main-navbar").css('top', 0-$(".main-navbar").innerHeight());
	$(".main-navbar").removeClass("hidden");

	// console.log($(this).innerWidth());

	if ( $(this).scrollTop() >= $("#header-section").height() ||
		$(this).innerWidth() < 800 )
		$(".main-navbar").addClass('active');

	$(window).scroll(function () {
		var header_height = $("#header-section").height();
		if ($(this).scrollTop() >= header_height ||
			$(this).innerWidth() < 800 )
		{
			$(".main-navbar").addClass('active');
			// console.log(header_height + " " + $(this).scrollTop());
		} else {
			$(".main-navbar").removeClass('active');
		}
	});

	$(window).resize(function () {
		var header_height = $("#header-section").height();
		if ($(this).scrollTop() >= header_height ||
			$(this).innerWidth() < 800 )
		{
			$(".main-navbar").addClass('active');
			// console.log(header_height + " " + $(this).scrollTop());
		} else {
			$(".main-navbar").removeClass('active');
		}
	});

});


jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
